import React from "react";
import PanelHead from "../../UI/Panel/PanelHead";
import PanelBody from "../../UI/Panel/PanelBody";
import { PinTable } from "../../UI/Advertising/pin/PinTable";

const PinPanel = () => {
  return (
    <div>
      <PanelHead title="Pins" />
      <PanelBody content={<PinTable />} />
    </div>
  );
};

export default React.memo(PinPanel);
